module.exports = __webpack_public_path__ + "france.2648a71e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/countries/france.png
// module id = 123
// module chunks = 0